"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PersonalPostViewNavigation_1 = __importDefault(require("./PersonalPostViewNavigation"));
var PostContentWrapper_1 = __importDefault(require("../PostContentWrapper"));
var PostViewContentTypes_1 = require("../../../constants/PostViewContentTypes");
var ApartmentInfoSection_1 = __importDefault(require("../ApartmentInfoSection"));
var BuildingInfoSection_1 = __importDefault(require("../BuildingInfoSection"));
var MortgageSection_1 = __importDefault(require("../MortgageSection"));
var objectHelper_1 = require("../../../helpers/objectHelper");
var GeneralSettings_1 = require("../../../constants/GeneralSettings");
var PostContent = function (_a) {
    var _b, _c;
    var isScrolled = _a.isScrolled, scrollTopPosition = _a.scrollTopPosition, handleVerticalScroll = _a.handleVerticalScroll, postData = _a.postData, isRent = _a.isRent;
    var tabsRef = react_1.useRef(null);
    var _d = react_1.useState(PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO), tabIsShown = _d[0], setTabIsShown = _d[1];
    var _e = react_1.useState(false), isClicked = _e[0], setIsClicked = _e[1];
    var _f = react_1.useState(100), navHeight = _f[0], setNavHeight = _f[1];
    var _g = react_1.useState(0), smallestAbsoluteDistance = _g[0], setSmallestAbsoluteDistance = _g[1];
    var personalApartment = react_1.useState([
        objectHelper_1.combineApartmentsData({
            apt_number: postData.publicCode,
            price: postData.price,
            currency: isRent
                ? (_b = postData.dailyPriceFull[0]) === null || _b === void 0 ? void 0 : _b.currency
                : (_c = postData.priceFull[0]) === null || _c === void 0 ? void 0 : _c.currency,
        }),
    ])[0];
    var personalTabItems = [
        {
            tabName: PostViewContentTypes_1.SECTION_TYPES.APARTMENT_INFO,
            tabContent: (react_1.default.createElement(ApartmentInfoSection_1.default, { postData: postData, isRent: isRent })),
        },
        {
            tabName: PostViewContentTypes_1.SECTION_TYPES.BUILDING_INFO,
            tabContent: react_1.default.createElement(BuildingInfoSection_1.default, { postData: postData }),
        },
        {
            tabName: PostViewContentTypes_1.SECTION_TYPES.MORTGAGE_INFO,
            tabContent: !isRent &&
                postData.property_type !== GeneralSettings_1.PROPERTY_TYPES.COMMERCIAL ? (react_1.default.createElement(MortgageSection_1.default, { freeApartments: personalApartment, isDeveloper: postData.isDeveloper, region: postData.addressData.state, district: postData.addressData.district, address: postData.addressData.address, propertyType: postData.propertyType })) : (react_1.default.createElement(react_1.default.Fragment, null)),
        },
    ];
    var checkNavHeight = function (height) {
        setNavHeight(height);
    };
    var checkSmallestAbsoluteDistance = function (value) {
        setSmallestAbsoluteDistance(value);
    };
    var handleChangeTab = function (tab, position) {
        setTabIsShown(tab);
        if (position) {
            handleVerticalScroll(position - navHeight);
        }
    };
    var handleClick = function (value) {
        setIsClicked(value);
    };
    return (react_1.default.createElement("div", { ref: tabsRef },
        react_1.default.createElement(PersonalPostViewNavigation_1.default, { tabIsShown: tabIsShown, handleChangeTab: handleChangeTab, handleClick: handleClick, checkNavHeight: checkNavHeight, isRent: isRent, propertyType: postData.propertyType }),
        personalTabItems.map(function (tab) { return (react_1.default.createElement(PostContentWrapper_1.default, { key: tab.tabName, tabItemName: tab.tabName, tabContent: tab.tabContent, isClicked: isClicked, scrollTopPosition: scrollTopPosition, isScrolled: isScrolled, handleClick: handleClick, tabIsShown: tabIsShown, handleChangeTab: handleChangeTab, checkSmallestAbsoluteDistance: checkSmallestAbsoluteDistance, smallestAbsoluteDistance: smallestAbsoluteDistance, navHeight: navHeight })); })));
};
exports.default = PostContent;
